import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';

import * as ds from './dataService';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  Typography,
  useTheme
} from '@mui/material';



export type UserProfileDetailCardProps = {};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: UserProfileDetailCardProps) => {
  const { data } = ds.useQuery();
  const theme = useTheme();
  const [
    fnSaveNotification,
    { loading }
  ] = ds.useSaveNotification();

  return (
    <Box
      display='flex'
      flexDirection='column'
      rowGap='1rem'
    >
      <>
        {fields.map((node, i) => {
          const Icon = field2Icon[node];
          return (
            <Stack
              key={`profile-row-${i}`}
              direction='row'
              columnGap='.5rem'
              alignItems='center'
            >
              <Icon
                stroke={theme.palette.primary.main}
              />
              <Typography variant='formLabel'>{field2Label[node]}</Typography>
              <Typography variant='formInput'>{data[node]}</Typography>

            </Stack>
          );
        })}
        <FormControl>
          <Typography
            variant='bodyBold'
          >
            Notification Settings
          </Typography>
          <FormGroup>
            {data.settings.map((setting, i) => {
              return (
                <FormControlLabel
                  key={`notification-row-${i}`}
                  control={(
                    <Switch
                      checked={setting.enabled}
                      onChange={async () => {
                        if (!loading) {
                          await fnSaveNotification(setting.id);
                        }
                      }}
                    />
                  )}
                  label={setting.label}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </>


    </Box>
  );
};


const fields: (keyof Omit<ds.IData, 'id' | 'settings'>)[] = [
  'firstName',
  'lastName',
  'phoneNumber',
  'preferredEmail',
  'createdDate'
];



const field2Label: Record<typeof fields[number], string> = {
  firstName: 'First Name',
  lastName: 'Last Name',
  phoneNumber: 'Phone Number',
  preferredEmail: 'Preferred Email',
  createdDate: 'Created Date'
};

const field2Icon: Record<typeof fields[number], ({ stroke }: { stroke: string }) => ReactNode> = {
  firstName: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='DOC' stroke={stroke} />,
  lastName: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='DOC' stroke={stroke} />,
  phoneNumber: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='INFO' stroke={stroke} />,
  preferredEmail: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='MESSAGES' stroke={stroke} />,
  createdDate: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='CLOCK' stroke={stroke} />

};
